<template>
  <div class="metrics-container">
    <div v-for="item in data" :key="item.slotId" class="metric-chip">
      <div class="metric-title">{{ item.name }}</div>

      <div v-for="stat in item.stats" :key="stat.key" class="metric-row">
        <span class="metric-key">{{ formatKey(stat.key) }}:</span>
        <span class="metric-value">{{ formatValue(stat.value) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Meta from "@/_helpers/ModuleMeta";
export default {
  name: "MetricChips",
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatKey(key) {
      return (
        Meta.Keys.find((x) => x.key == key)
          ?.name?.split(" ")
          ?.at(1) ?? "Error"
      );
    },
    formatValue(value) {
      if (
        value == Infinity ||
        value == -Infinity ||
        value == undefined ||
        value == null
      )
        return "N/A";
      if (typeof value === "number") {
        return new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 2,
        }).format(value);
      }
      return value;
    },
  },
};
</script>

<style scoped>
.metrics-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 8px;
  max-width: 240px;
  width: 100%;
  padding: 1rem;
}

/* Chip styling */
.metric-chip {
  display: inline-flex;
  flex-direction: column;
  background: #f2f2f7;
  border-radius: 16px;
  padding: 8px 12px;
  font-size: 13px;
  color: #333;
  min-width: 220px;
  border: 1px solid #ddd;
}

.metric-title {
  font-weight: bold;
  margin-bottom: 4px;
}

/* Row layout */
.metric-row {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
}

.metric-key {
  opacity: 0.7;
}

.metric-value {
  font-weight: 600;
  margin-left: 6px;
}
</style>
